import { render, staticRenderFns } from "./FormSearchVastapuoli.vue?vue&type=template&id=7bad9524&scoped=true&"
import script from "./FormSearchVastapuoli.vue?vue&type=script&lang=js&"
export * from "./FormSearchVastapuoli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bad9524",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bad9524')) {
      api.createRecord('7bad9524', component.options)
    } else {
      api.reload('7bad9524', component.options)
    }
    module.hot.accept("./FormSearchVastapuoli.vue?vue&type=template&id=7bad9524&scoped=true&", function () {
      api.rerender('7bad9524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormSearchVastapuoli.vue"
export default component.exports